export default {
  title: {
    id: 'funnel_summary_title_with_details',
    defaultMessage: 'Your order',
  },
}
